import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs, Empty, Table } from 'antd';


import Footer from './Footer';
import auth from '../../../common/utility/auth';

import dialog from "../../../common/utility/dialog";
import moment from "moment";
const InputGroup = Input.Group;
const { TabPane } = Tabs;

class ViewPago extends React.Component {


  constructor(props) {
    super(props);
  }


  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (this.props.formValues.listaDetalleCredito.length == 0) {
          dialog.warning("Seleccione cuotas a pagar");
          return false;

        }
        this.props.onNext(values, this.props.form);
      }
    });
  };


  render() {

    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

    getFieldDecorator("listaFormaPagoOtros", {
      initialValue: this.props.formValues.listaFormaPagoOtros,
    });


    return (
      <Modal
        title={"Registrar Pago"}
        visible={this.props.visible}
        onCancel={this.props.onClose}
        style={{ top: 30 }}
        width={1200}
        footer={[
          <Button
            key="1"
            onClick={this.props.onClose}
          >
            Cancelar
          </Button>,
          <Button
            key="2"
            type="primary"
            onClick={this.handleOk}
          >
            Pagar
          </Button>
        ]}
      >
        <Form>


          <div className="row">
            <div className="col-md-3">
              <Form.Item label="Nro Documento">
                <Input readOnly
                  value={this.props.formValues.DocumentoCliente}
                />
              </Form.Item>
            </div>
            <div className="col-md-9">
              <Form.Item label="Cliente">
                <Input readOnly
                  value={this.props.formValues.RazonSocialClientemento}
                />
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Fecha Emisión">
                <Input readOnly
                  value={this.props.formValues.Fecha}
                  suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}

                />
              </Form.Item>


            </div>
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Tipo Cambio">
                <Input readOnly
                  value={this.props.formValues.tipoCambio}

                />
              </Form.Item>


            </div>
            <div className="col-md-3" hidden={this.props.visibleDetalle}>
              <Form.Item label="Nro Comprobante">
                <Input readOnly
                  value={this.props.formValues.nro_documento}
                />
              </Form.Item>
            </div>

            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Total Comprobante">
                <Input readOnly
                  value={this.props.formValues.Total.toFixed(2)}
                />
              </Form.Item>
            </div>

            <div className="col-md-3">
              <Form.Item label="Moneda Original">
                <Input readOnly
                  value={this.props.formValues.Moneda}
                />
              </Form.Item>
            </div>


          </div>


          <div className="row">
            <div className="col-md-12 form-group">

              <Tabs
                activeKey={this.props.formValues.activeKey}
              >

                <TabPane tab="Seleccionar Monto a Cobrar" key="3">
                  <div>
                    <Table
                      size="small"
                      style={{ overflowX: 'auto' }}
                      rowKey={record => record.idCuentasCobrarDetalle}
                      dataSource={this.props.formValues.listaDetalleCredito}
                      rowSelection={{
                        onChange: this.props.onChangeRow,
                        selectedRowKeys: this.props.formValues.selectedRowKeys,
                        hideDefaultSelections: false
                      }}
                      locale={{
                        emptyText: <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="No se encontraron datos."
                        />
                      }}
                      columns={[
                        {
                          title: 'Cuota',
                          dataIndex: 'couta',
                          key: 'couta'
                        },
                        {
                          title: 'Moneda Original',
                          dataIndex: 'moneda',
                          key: 'moneda'
                        },
                        {
                          title: 'Fecha de Vencimiento',
                          dataIndex: 'fechaVencimiento',
                          key: 'fechaVencimiento',
                          align:'center'
                        },
                        {
                          title: 'Por Cobrar',
                          dataIndex: 'montoCuota',
                          key: 'montoCuota',
                          render: (data) => (
                            <span>{data.toFixed(2)}</span>
                          )
                        }
                      ]}
                    />
                  </div>
                </TabPane>

              </Tabs>
            </div>
          </div>


        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ViewPago);
